export const fetchedDialogsSelector = (state) => state.fetchDialogs.fetchedDialogs
